import React from 'react';
import anime from 'animejs/lib/anime.es.js';

import { graficosSource } from '../funcs/vars';

var httpBuildQuery = require('http-build-query');

export default class Graficos extends React.Component{
  state = {
    post: false
  }

  componentDidMount(){
    window.scroll(0, 0);
  }

  get(){
    window.scroll(0, 0);
  }

  render(){
    return(
      <div id="generic_page" className="page fullpage graficos">
        <div id="generic_page_container">
          <h1 id="generic_page_container_h1">Gráficos</h1>
          <a style={{textTransform: 'uppercase', fontSize: '0.9rem', fontWeight: 600, display: 'inline-block', padding:'0.35rem 0.5rem', backgroundColor: '#f00143', color: 'white', marginBottom: '1rem'}} href={"https://www.animalpolitico.com/everyday-justice-mexico/graphics"}>
            English version
          </a>
          <div id="generic_page_container_binder">
            <div className="gp_graficos">
              {
                graficosSource.map(function(g){
                  return(
                    <div className="gp_graficos_g">
                      <a href={g} target="_blank">
                        <img src={g} />
                      </a>
                    </div>
                  )
                })
              }

            </div>


          </div>
        </div>
      </div>
    )
  }
}
